import { Box, Paper } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { DEFAULT_ELEVATION } from "lib/global";
import React from "react";
import { useHistory } from "react-router";

export default function PaperButton({
  children = "",
  icon = "",
  onClick = () => {},
  onContextMenu = () => {},
  to = "",
  className = "",
  background = "",
  color = "secondary",
  variant = "contained",
  elevation = DEFAULT_ELEVATION,
  iconPosition = "end",
}) {
  const history = useHistory();
  const isText = typeof children === "string";

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick();
    } else if (to) {
      history.push(to);
    }
  };

  const handleContextMenu = () => {
    if (typeof onClick === "function") {
      onContextMenu();
    } else if (to) {
      history.push(to);
    }
  };

  const rendered = isText ? (
    <CustomText
      variant="body2"
      color={color}
      bold={600}
      className={`${className} transition-all duration-300 ${
        variant === "text"
          ? `border-b border-transparent hover:border-${color}`
          : ""
      }`}
    >
      {children}
    </CustomText>
  ) : (
    children
  );

  const ButtonContainer = variant === "text" ? Box : Paper;

  return (
    <ButtonContainer
      elevation={elevation}
      className={`${background} cursor-pointer flex justify-between items-center transition-all duration-300
        ${isText ? "px-4 py-2" : ""}
        ${variant === "outlined" ? "border border-bright-gray" : ""}
        ${variant === "text" ? "" : "hover:shadow-lg"}
      `}
      onClick={handleClick}
      onContextMenu={handleContextMenu}
    >
      {iconPosition === "start" && icon && (
        <div className="mr-2 -mt-1">{icon}</div>
      )}
      {rendered}
      {iconPosition === "end" && icon && (
        <div className="ml-2 -mt-1">{icon}</div>
      )}
    </ButtonContainer>
  );
}
